var map = {
	"./arrow-left.svg": "f6db",
	"./arrow-left2.svg": "3f52",
	"./clock.svg": "3175",
	"./close.svg": "bb7c",
	"./heart.svg": "6768",
	"./phone.svg": "1f9a",
	"./placeholder.svg": "1311",
	"./play.svg": "af53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";